import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useFocusStyles = makeStyles(() =>
    createStyles({
        visibleFocus: {
            "&.Mui-focusVisible": { outline: "2px solid black" },
        },
    }),
);